import { Guid, Nillable } from '@web/utils';
import { AdminBoxStatus } from '../enums/admin-box-status';

export class AdminBoxCollectionItem {
  public constructor(
    private readonly data: {
      boxSaleId?: Nillable<Guid>;
      canBeBoxSaleCreated: boolean;
      canBeBoxSaleViewed: boolean;
      canBeOrdersCompleted: boolean;
      canBeOrdersCompletedSimulated: boolean;
      canDownloadLabels: boolean;
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      createdAt: Date;
      featuredFileAlt?: Nillable<string>;
      featuredFileUrl?: Nillable<string>;
      id: Guid;
      name: string;
      price?: Nillable<number>;
      availableQuantity?: Nillable<number>;
      slug: string;
      status: AdminBoxStatus;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get featuredFileUrl(): Nillable<string> {
    return this.data.featuredFileUrl;
  }

  public get featuredFileAlt(): Nillable<string> {
    return this.data.featuredFileAlt;
  }

  public get price(): Nillable<number> {
    return this.data.price;
  }

  public get availableQuantity(): Nillable<number> {
    return this.data.availableQuantity;
  }

  public get status(): AdminBoxStatus {
    return this.data.status;
  }

  public get shopPreviewUrl(): string {
    return this.data.slug;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get canBeBoxSaleViewed(): boolean {
    return this.data.canBeBoxSaleViewed;
  }

  public get canBeOrdersCompleted(): boolean {
    return this.data.canBeOrdersCompleted;
  }

  public get canBeOrdersCompletedSimulated(): boolean {
    return this.data.canBeOrdersCompletedSimulated;
  }

  public get canDownloadLabels(): boolean {
    return this.data.canDownloadLabels;
  }

  public get canBeBoxSaleCreated(): boolean {
    return this.data.canBeBoxSaleCreated;
  }

  public get boxSaleId(): Nillable<Guid> {
    return this.data.boxSaleId;
  }
}
